import { UtilsService } from "@shared/services/utils.service";

export var subMenuItems: any[] = [];

subMenuItems.push({
  icon: 'assets/icons/icon_cash.png',
  title: 'CAJA',
  route: '/panel/payments',
});

subMenuItems.push({
  icon: 'assets/icons/icon_cash_closing.png',
  title: 'CERRAR CAJA',
  route: '/panel/payments/cashclose',
});


subMenuItems.push({
  icon: 'assets/icons/icon_list.png',
  title: 'LISTA DE TICKETS',
  route: '/panel/payments/summary',
});


subMenuItems.push({
  icon: 'assets/icons/icon_print.png',
  title: 'CREAR FACTURA',
  route: '/panel/payments/invoices/create',
});
// subMenuItems.push({
//   icon: 'assets/icons/icon_print.png',
//   title: 'DETALLES TICKET',
//   route: '/panel/payments/invoices/tickets',
// });
